
<workflow-no-access [workflowTargetInfo]="workflowTargetInfo"></workflow-no-access>
<div class="container" [hidden]="!workflowTargetInfo.correctRole">
  <div class="row step-description-block">
    <div class="col">
      <div class="float-left">
        <p>Site Assets</p>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <error [error]="error"></error>
    </div>
  </div>
  <div class="row" *ngIf="showManualDesign">
    <div class="alert alert-warning" style="width: 100%;"><span>Contacts may not be added to the MDF.</span></div>
  </div>
  <div class="row" *ngIf="loading">
    <md-spinner-block></md-spinner-block>
  </div>
  <div class="row" *ngIf="!loading">
    <div class="col table-card">
      <list-controls [search]="searchText" [limit]="pageSize" [page]="currentPage" [numPages]="maxPages" [totalCount]="totalCount" (onChange)="onListControlsChange($event)">
        <div class="dropdown">
          <button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown" [disabled]="isLocked">Add Assets</button>
          <div class="dropdown-menu dropdown-menu-right"><a class="dropdown-item" [href]="'#/workflow/' + workflowService.workflowConfig.id + '/addAssets/importCDF'" *ngIf="showImportCDF">Import CDF from SOLD</a><a class="dropdown-item" [downloadFile]="'/api/sites/export-assets/' + workflowTargetInfo.targetId" *ngIf="showManualDesign">Export Manual Design File</a><a class="dropdown-item" [uploadFileTo]="'/api/sites/import-assets/' + workflowTargetInfo.targetId" *ngIf="showManualDesign" [fileExtensions]="['xls', 'xlsx', 'xlsm', 'xlsb']" [title]="'Import Assets'" (closed)="fileUploaded()">Import Manual Design File</a><a class="dropdown-item" [href]="'#/workflow/' + workflowService.workflowConfig.id + '/' + stepName + '/devices'" *ngIf="showAddIndividualAssets">Add Individual Assets</a><a class="dropdown-item" href="javascript:void(0);" (click)="showDartCorrectionDialog()">Request DART Correction</a></div>
        </div>
      </list-controls>
      <table class="table table-responsive">
        <thead>
          <tr class="table-header-with-controls">
            <th>SKU</th>
            <th>Description</th>
            <th>Device Key</th>
            <th>Bundle Number</th>
            <th>Serial Number</th>
            <th *ngIf="!isLocked">Actions</th>
          </tr>
        </thead>
        <tbody>
          <ng-template ngFor let-asset [ngForOf]="assets">
            <tr>
              <td>{{ asset.productNumber }}</td>
              <td><span class="badge badge-secondary mr-2" *ngIf="asset.quicksilver">QS</span><b *ngIf="asset.type === &quot;accessory&quot;">Accessory:</b> {{ asset.friendlyName || asset.description }}
                <p class="text-red" *ngIf="!asset.hasDisposition &amp;&amp; asset.deviceKey">This DART device is misconfigured.  Please update the DART deal in Transition Management Central.</p>
                <p class="text-red" *ngIf="asset.assetShouldBeAccessory">This asset should be an accessory. <a class="btn btn-danger btn-sm" href="javascript:void(0)" (click)="fixAccessory(asset)">FIX</a>
                </p>
              </td>
              <td>
                <p *ngIf="asset.deviceKey">{{ asset.deviceKey }}</p>
                <p class="text-red" *ngIf="!asset.deviceKey">REMOVAL</p>
              </td>
              <td>{{ asset.bundleNumber }}</td>
              <td>{{ asset.serialNumber }}</td>
              <td *ngIf="!isLocked">
                <div class="btn-group">
                  <button class="btn btn-outline-danger btn-sm" (click)="remove(asset)" [disabled]="asset.installed || asset.lockedToSite || asset.ordered">Delete</button>
                  <button class="btn btn-outline-primary btn-sm" (click)="edit(asset)" [disabled]="asset.installed || asset.ordered">Edit</button>
                </div>
              </td>
            </tr>
            <tr class="no-top-border no-top-padding" *ngFor="let accessory of asset.accessories">
              <td>{{ accessory.productNumber }}</td>
              <td><b>Accessory:</b> {{ accessory.description }}</td>
              <td>{{ accessory.deviceKey }}</td>
              <td>{{ accessory.bundleNumber }}</td>
              <td>{{ accessory.serialNumber }}</td>
              <td *ngIf="!isLocked">
                <div class="btn-group">
                  <button class="btn btn-outline-danger btn-sm" (click)="remove(accessory)" [disabled]="accessory.installed || accessory.lockedToSite || accessory.ordered">Delete</button>
                  <button class="btn btn-outline-primary btn-sm" (click)="edit(accessory)" [disabled]="accessory.installed || accessory.ordered">Edit</button>
                </div>
              </td>
            </tr>
          </ng-template>
          <tr *ngIf="assets.length === 0">
            <td colspan="8">
              <p class="text-center empty-table-message">There are no assets to display.</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>